module.exports = __webpack_public_path__ + "img/maintop.9d30afb.png";